import { PropsWithChildren } from "react";
import { ChanelCustomContextProvider } from "./chanel/chanel-custom-context-provider";

type CustomContextProviderProps = {
  applicationKey?: string;
};

// アプリIDに応じてカスタムコンテキストを出しわける
export const CustomContextProvider = ({
  applicationKey,
  children,
}: PropsWithChildren<CustomContextProviderProps>) => {
  // TODO: look-back 用のカスタムコンテキストを追加
  if (applicationKey === "chanel" || applicationKey === "look-back") {
    return (
      <ChanelCustomContextProvider>{children}</ChanelCustomContextProvider>
    );
  }

  return <>{children}</>;
};
